// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"62":"c2d00140","356":"a9d2d7ae","534":"07efc207","642":"de82ad54"}[chunkId] + ".chunk.js";
};